module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee@2x_e2be7b.jpg";